import Alert from './Alert';
import Channel from './Channel';

export default class SingleAlert extends Alert {
  constructor(
    id,
    description,
    triggeredAlertEvent,
    timezone,
    lastReading,
    triggerCondition,
    clearCondition,
    temperatureScale,
    alertActionList,
    isDeviceAssignmentSuspended,
    isAlertDeactivated,
    isAcknowledged,
    isFavorite,
    channelKey,
    customTemplate,
    customUnits,
    additionalChannelKeys,
    channel,
    hasAdvancedAlerting,
    tagIds,
  ) {
    super(
      id,
      description,
      triggeredAlertEvent,
      timezone,
      lastReading,
      triggerCondition,
      clearCondition,
      temperatureScale,
      alertActionList,
      isDeviceAssignmentSuspended,
      isAlertDeactivated,
      isAcknowledged,
      isFavorite,
      channelKey,
      customTemplate,
      customUnits,
      additionalChannelKeys,
      tagIds,
    );

    this.channel = new Channel(
      channel.id,
      channel.type,
      channel.name,
      channel.groupName,
      channel.deviceName,
      channel.deviceAssignmentId,
      channel.deviceId,
      channel.unit,
    );
    this.hasAdvancedAlerting = hasAdvancedAlerting;
  }
}
